import styled, { css } from 'styled-components';
import { radius } from '@/styles/Themes/Metrics';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { cssVars } from '@/styles/Themes/cssVars';
import { DropdownArrow } from '@/shared/images/icons/DropdownArrow';
import Palette from '@/styles/Themes/Palette';
import { Transition } from '@/styles/Themes/KeyFrames';

export const ShortParagraph = styled.div<{ leftAlign?: boolean; markdown?: boolean }>`
    top: 30px;
    width: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: ${({ leftAlign }) => (leftAlign ? 'start' : 'center')};
    border-radius: ${radius.small};
    margin: 16px auto;
    background-color: ${cssVars.bg_ash_dark3};
    color: ${cssVars.fg_gray2_gray3};
    ${Text.Full.large.regular};

    ${Screen.desktop} {
        max-width: 1064px;
        margin: 24px auto;
        padding: 20px 40px;
    }

    ${({ markdown }) =>
        markdown &&
        css`
            a {
                color: ${cssVars.fg_green_greenLight};
                text-decoration: underline;
                font-weight: 500;
            }

            div {
                ${Text.Full.medium.regular};
            }
            ul {
                padding-left: 10px;
                margin: 0;
            }

            li::marker {
                content: '- ';
            }
        `}
`;

export const DescriptionTitle = styled.h1`
    ${Text.Mobile.heading2};
    color: ${cssVars.fg_gray1_white};

    ${Screen.ipad} {
        ${Text.Ipad.heading3};
    }

    ${Screen.desktop} {
        ${Text.Desktop.heading2};
    }
`;

export const Data = styled.div`
    color: ${cssVars.fg_gray2_gray3};
    ${Text.Mobile.heading4.regular};
    margin-bottom: 20px;

    a {
        color: ${cssVars.fg_green_greenLight};
        text-decoration: underline;
        font-weight: 500;
    }

    div {
        ${Text.Full.medium.regular};
    }
    ul {
        padding-left: 10px;
        margin: 0;
    }

    li::marker {
        content: '- ';
    }

    ${Screen.ipad} {
        ${Text.Full.large.regular};
    }
`;

export const Paragraph = styled.div`
    margin: 16px 0;

    ${Screen.desktop} {
        margin: 32px 0;
    }
`;

export const ReadMore = styled.span<{ isActive: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 36px;
    ${Text.Full.large.medium}
    color: ${Palette.green.normal};
    ${Transition.normal};
    margin-bottom: 13px;
    cursor: pointer;
`;

export const Arrow = styled(DropdownArrow)<{ isActive: boolean }>`
    margin-left: 6px;
    fill: ${Palette.green.normal};
    ${({ isActive }) => isActive && 'transform: rotate(-180deg);'}
    ${Transition.normal};
`;
